import Overview from '../../modules/Overview/Overview';

function PageOverview() {
    return <Overview />;
}

export default PageOverview;
